"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.SROnlyFocusable = exports.SROnly = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var SROnly = _styledComponents.default.span.withConfig({
  displayName: "SROnly",
  componentId: "sc-d5if1o-0"
})(["border:0 !important;clip:rect(1px,1px,1px,1px) !important;-webkit-clip-path:inset(50%) !important;clip-path:inset(50%) !important;height:1px !important;overflow:hidden !important;padding:0 !important;position:absolute !important;width:1px !important;white-space:nowrap !important;"]);

exports.SROnly = SROnly;

var SROnlyFocusable = _styledComponents.default.span.withConfig({
  displayName: "SROnlyFocusable",
  componentId: "sc-d5if1o-1"
})(["clip:auto !important;-webkit-clip-path:none !important;clip-path:none !important;height:auto !important;overflow:visible !important;width:auto !important;white-space:normal !important;"]);

exports.SROnlyFocusable = SROnlyFocusable;